// extracted by mini-css-extract-plugin
module.exports = {"ColorSelect":"ColorSelect_ColorSelect__2RKIj"};